import request from '@/utils/request'

// 人才招聘列表
export function getRecruit(data) {
    return request({
        url: '/gtwg/pc/recruitList',
        method: 'get',
        params:data
    })
}
// 人才招聘明细
export function getRecruitDetail(data) {
    return request({
        url: '/gtwg/pc/recruitDetails',
        method: 'get',
        params:data
    })
}
